import React, { memo } from 'react'

export const NewsArticle = memo(({ title, pressNm, publishedDt }) => {
  return (
    <article className={'border-b-navy-300 border-b py-20'}>
      <h4 className={'text-16 truncate font-bold'}>{title}</h4>
      <span className={'text-14 text-navy-500'}>
        {pressNm} · {publishedDt}
      </span>
    </article>
  )
})